module.exports = {
	ecommerce: {
		HOST: "https://api.calzzapato.xyz/api",
		AUTH_USERNAME: "Choix",
		AUTH_PASSWORD: "Ch01x#2025*",
		ENCRYPTION_SECRET_KEY: "h9F7T$o&L2YJ@1qnMzR!4*XWpVAgk#dW"
	},
};
